import React, { useState, useEffect } from "react";
import { Table, Switch, Card, Button, message } from "antd";
import axios from "axios";
import config from "../../config.json";

const InspectionReminder = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Fetch user data
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await axios.get(config.api + "userEmail");
        setUsers(res.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
      setLoading(false);
    };

    fetchUsers();
  }, []);

  const handleSwitchChange = (userId, level, value) => {
    const updatedUsers = users.map((user) =>
      user._id === userId
        ? { ...user, levels: { ...user.levels, [level]: value } }
        : user
    );
    setUsers(updatedUsers);
  };

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      // Call PATCH for each user one by one
      for (const user of users) {
        await axios.patch(config.api + "userEmail/" + user._id, {
          levels: user.levels,
        });
      }
      message.success("All users updated successfully");
    } catch (error) {
      console.error("Failed to save all changes:", error);
      message.error("Failed to save all changes");
    }
    setSaving(false);
  };

  const columns = [
    {
      title: "User",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Level 1",
      key: "level1",
      render: (_, record) => (
        <Switch
          checked={record.levels?.level1}
          onChange={(val) => handleSwitchChange(record._id, "level1", val)}
        />
      ),
    },
    {
      title: "Level 2",
      key: "level2",
      render: (_, record) => (
        <Switch
          checked={record.levels?.level2}
          onChange={(val) => handleSwitchChange(record._id, "level2", val)}
        />
      ),
    },
    {
      title: "Level 3",
      key: "level3",
      render: (_, record) => (
        <Switch
          checked={record.levels?.level3}
          onChange={(val) => handleSwitchChange(record._id, "level3", val)}
        />
      ),
    },
  ];

  return (
    <Card title="User Notification Settings" style={{ margin: 20 }}>
      <Table
        dataSource={users}
        columns={columns}
        rowKey="_id"
        loading={loading}
        pagination={false}
      />
      <Button
        type="primary"
        style={{ marginTop: 16 }}
        loading={saving}
        onClick={handleSaveAll}
      >
        Save All Changes
      </Button>
    </Card>
  );
};

export default InspectionReminder;
